<form #formulari="ngForm">            
    <p i18n>Tipus d'arxiu suportats: 'pdf', 'doc', 'jpg', 'docx', 'jpeg', 'png', 'odt', 'rtf'</p>
    <mat-grid-list cols="5" rowHeight="80px">       
        <div *ngFor="let doc of preinscripcio.documents">
            <mat-grid-tile colspan="2">
                <span class="pre-controls-right">
                    {{doc.tipusDocument.name}} <span *ngIf="doc.obligatori">*</span>
                </span>                            
            </mat-grid-tile>
            <mat-grid-tile *ngIf="preinscripcio.potModificar && doc.potModificar">
                <label role="button" class="mdl-button mdl-js-button mdl-button--raised" *ngIf="!doc.waiting">
                    <input type="file" (change)="filesSelect(doc, $event.target.files)" hidden>
                    <span *ngIf="!doc.nom" i18n>Puja</span>
                    <span *ngIf="doc.nom" i18n>Modifica</span>        
                </label>
                <span *ngIf="doc.waiting">
                        <p i18n>Pujant el fitxer...</p>
                        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                </span>                                                        
                <span *ngIf="doc.nom" role="button" class="mdl-button mdl-js-button mdl-button--raised" (click)="eliminaDocumentPreinscripcio(doc)" i18n>
                    Elimina
                </span>
            </mat-grid-tile>
            <mat-grid-tile colspan="2">
                <span class="pre-controls-left">
                    <small *ngIf="doc.nom">{{doc.nom}}</small>
                    <small *ngIf="!doc.nom"><div [innerHTML]="doc.descripcio"></div></small>
                </span>
            </mat-grid-tile>                        
        </div>                
        <mat-grid-tile colspan="5">
            <div i18n>
                * Documents obligatoris. La resta de documents els podràs adjuntar en un altre moment però cal que tinguis en compte la sol·licitud no es resoldrà si no els hi adjuntes.
            </div>
        </mat-grid-tile>           
        <mat-grid-tile colspan="5" *ngIf="preinscripcio.potModificar">
            <div *ngIf="waiting">
                <p i18n>Processant la informació, espera un moment...</p>
                <mat-progress-bar mode="indeterminate"></mat-progress-bar>
            </div>            
            <div class="pre-controls-right" *ngIf="!waiting">
                <button mat-raised-button matStepperPrevious i18n>Torna</button>
                <button mat-raised-button color="primary" (click)="continua()" [disabled]="!isValid()" i18n>Continua</button>            
            </div>
        </mat-grid-tile>
    </mat-grid-list>                                
</form>



// WEBPACK FOOTER //
// ./src/app/documentacio/documentacio.component.html